export function returnGraphqlError(e) {
  e.graphQLErrors.map(x => console.log(`Error: ${x.message}`))

  return null
}
